<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

import { getWidgets } from '../../widgets'

import type { CustomWidget } from '@/api/widgets'
import type { Component } from 'vue'

import { fetchCustomWidgets } from '@/api/widgets'

const route = useRoute()
const lenaWidgets = getWidgets()
const widgets = ref<CustomWidget[]>([])

// Находим общие виджеты
const commonWidgets = computed(() => {
  if (!widgets.value || !lenaWidgets) return []

  return widgets.value.filter((serverWidget) => {
    return serverWidget.Data.Show && lenaWidgets.some((lenaWidget: any) =>
      lenaWidget?.name === serverWidget.Info.MachineName
    )
  })
})

// Формируем компоненты для :is
const dynamicComponents = computed(() => {
  const components: Record<string, Component> = {}

  lenaWidgets.forEach((widget: any) => {
    if (widget.name && widget.component) {
      components[widget.name] = widget.component
    }
  })

  return components
})

const init = async () => {
  const formData = new FormData()
  formData.append('EmployeeUuid', route.params.uuid as string)
  formData.append('AdapterUuid', 'b77daf1e-8534-402f-b0c3-8b616838f3e8')

  try {
    widgets.value = await fetchCustomWidgets(formData)
  } catch (error) {
    console.error('Error fetching widgets:', error)
  }
}

init()
</script>

<template>
  <VRow align="stretch">
    <VCol
      v-for="widget in commonWidgets"
      :key="widget.Info.MachineName"
      :lg="4"
      :md="6"
      :sm="12"
      class="d-flex"
    >
      <component
        v-if="dynamicComponents[widget.Info.MachineName]"
        :is="dynamicComponents[widget.Info.MachineName]"
        :custom-widget="widget"
      />
    </VCol>
  </VRow>
</template>
